module.exports = __webpack_public_path__ + "img/1.be7869e1.png";